/**
 * Save a key-value pair in session storage.
 * @param key The key to save in session storage.
 * @param value The value to save (string or serializable object).
 */
export function setSessionItem(key: string, value: any): void {
    try {
        const serializedValue = typeof value === 'string' ? value : JSON.stringify(value);
        sessionStorage.setItem(key, serializedValue);
    } catch (error) {
        console.error('Error saving to session storage', error);
    }
}

/**
 * Retrieve a value from session storage by its key.
 * @param key The key to retrieve from session storage.
 * @returns The retrieved value or `null` if the key doesn't exist.
 */
export function getSessionItem<T = any>(key: string): T | null {
    try {
        const item = sessionStorage.getItem(key);
        return item ? (isJsonString(item) ? JSON.parse(item) : (item as T)) : null;
    } catch (error) {
        console.error('Error retrieving from session storage', error);
        return null;
    }
}

/**
 * Remove a key-value pair from session storage.
 * @param key The key to remove from session storage.
 */
export function removeSessionItem(key: string): void {
    try {
        sessionStorage.removeItem(key);
    } catch (error) {
        console.error('Error removing from session storage', error);
    }
}

/**
 * Check if a string is valid JSON.
 * @param str The string to validate.
 * @returns `true` if the string is JSON, otherwise `false`.
 */
function isJsonString(str: string): boolean {
    try {
        JSON.parse(str);
        return true;
    } catch {
        return false;
    }
}

export function validateToken(token: string): boolean {
    if (!token) return false;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const now = Math.floor(Date.now() / 1000);
      return payload.exp > now;
    } catch (e) {
      return false;
    }
  }
